import React from "react";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
// import AuthHelperMethods from "./AuthHelperMethods";
import CheckoutForm from "./subscriptionForm";
import Auth from "./Auth";

//import api from "./api";

const PaymentSubscription = (props) => {
  const getPublicStripeKey = async () => {
    const result = await Auth.api("payments/getPublicStripeKey", "get");
    return result.data.publicKey;
  };

  const stripePromise = getPublicStripeKey().then((key) => loadStripe(key));
  console.log(getPublicStripeKey());

  return (
    <>
      <Elements stripe={stripePromise}>
        <CheckoutForm {...props} />
      </Elements>
    </>
  );
};

export default PaymentSubscription;
